import mtop from '@ali/arise-h5-utils-mtop';

const APP_ID = '1';

const getData = async (platform) => {
  const data = JSON.stringify({
    appId: APP_ID,
    regionId: window.g_config && window.g_config.regionID,
    lang: window.g_config && window.g_config.language,
    appVersion: '1.0.0',
    platform,
    bizId: '1000006',
  });
  const api = 'mtop.arise.ald.homepage.service';
  try {
    const resp = await mtop.request({
      api,
      v: '1.0',
      dataType: 'json',
      type: 'GET',
      data,
      ecode: 1,
    });
    const { global, modules } = resp.data.resultValue[APP_ID].data[0];
    return { global, modules };
  } catch (error) {
    return { global: {}, modules: [] };
  }
};

export default getData;

export const getVoucher = async (appId, platform, extend) => {
  const data = JSON.stringify({
    appId,
    regionId: window.g_config && window.g_config.regionID,
    lang: window.g_config && window.g_config.language,
    appVersion: '1.0.0',
    platform,
    bizId: '1000006',
    extend,
  });
  const api = 'mtop.arise.ald.homepage.service';
  const resp = await mtop.request({
    api,
    v: '1.0',
    dataType: 'json',
    type: 'GET',
    data,
    ecode: 1,
  });
  return resp.data.resultValue[appId].data;
};

let __popUpData = null;
export const getNuPopupJumpLand = () => {
  __popUpData = __popUpData || sessionStorage.getItem('nuPopup_jump_land');
  if (__popUpData) {
    sessionStorage.removeItem('nuPopup_jump_land');
  }
  return __popUpData;
};
